import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { emptySplitApi } from "../pages/api/apiSlice";
import { emptySplitHistoryApi } from "../pages/api/historyApiSlice";
import { emptySplitCRMApi } from "../pages/api/crmApiSlice";
import { emptySplitWAOrderApi } from "../pages/api/waOrderApiSlice";


import appUserReducer from "./appUserReducer";
import restaurantReducer from "./restaurantReducer";
import notificationReducer from "./notificationReducer";
import messageReducer from "./messageReducer";
import printersReducer from "./printersReducer";
import customerSettingsReducer from "./customerSettingsReducer";

export const store = configureStore({
  reducer: {
    [emptySplitApi.reducerPath]: emptySplitApi.reducer,
    [emptySplitHistoryApi.reducerPath]: emptySplitHistoryApi.reducer,
    [emptySplitCRMApi.reducerPath]: emptySplitCRMApi.reducer,
    [emptySplitWAOrderApi.reducerPath]: emptySplitWAOrderApi.reducer,
    appUser: appUserReducer,
    message: messageReducer,
    restaurant: restaurantReducer,
    notification: notificationReducer,
    printers: printersReducer,
    customerSettings: customerSettingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(emptySplitApi.middleware)
      .concat(emptySplitHistoryApi.middleware)
      .concat(emptySplitCRMApi.middleware)
      .concat(emptySplitWAOrderApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
